import { FunctionComponent, useState } from 'react'
import classNames from 'classnames'
import { Swiper } from 'swiper/types'
import { Grid } from 'swiper/modules'
import { RowType, Swimlane as SwimlaneProps } from './Swimlane.types'
import { BaseCarousel } from '../primitives/BaseCarousel/BaseCarousel'
import { UXComponentRenderer } from '../UXComponentRenderer/UXComponentRenderer'
import { SwimlaneNavigation } from './SwimlaneNavigation'
import 'swiper/scss'
import 'swiper/scss/navigation'
import 'swiper/scss/pagination'
import 'swiper/scss/free-mode'
import 'swiper/scss/grid'
import './Swimlane.scss'

export const Swimlane: FunctionComponent<SwimlaneProps> = ({ attributes }) => {
  const {
    items,
    spaceBetween,
    pagination,
    justifyContent,
    rowType
  } = attributes
  const [swiperInstance, setSwiperInstance] = useState<Swiper | null>(null)

  const swiperSettings = {
    ...(spaceBetween || spaceBetween === 0 ? { spaceBetween } : {}),
    onSwiper: (swiper: Swiper) => {
      setSwiperInstance(swiper)
    },
    allowTouchMove: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    navigation: false,
    modules: [Grid],
    ...(rowType === RowType.DOUBLE && {
      spaceBetween: -10,
      slidesPerView: 4,
      grid: {
        rows: 2,
        fill: 'row' as const
      }
    })
  }

  return (
    <div
      className={classNames('swimlane-ux-component', {
        'swimlane-ux-component--double': rowType === RowType.DOUBLE
      })}
      style={
        {
          '--swiper-wrapper-justify-content': justifyContent
        } as React.CSSProperties
      }
      data-testid="swimlane">
      <BaseCarousel
        className="swimlane-ux-component__carousel"
        items={items.map((item, index) => (
          <UXComponentRenderer {...item} index={index} />
        ))}
        swiperProps={swiperSettings}
      />

      {swiperInstance && (
        <SwimlaneNavigation
          swiper={swiperInstance}
          withCustomPagination={!!pagination}
        />
      )}
    </div>
  )
}
